<template>
  <el-select v-model="colorValue" :class="$darkMode.selectClass()" style="display: block" @change="elementClicked">
    <el-option v-for="col in acceptedValues" :key="col" :class="$darkMode.selectClass()" :value="col" :label="col">
      <badge-color :tag="tag" :color="col">{{ col }}</badge-color>
    </el-option>
  </el-select>
</template>
<script>
import { BadgeColor } from '@/components'
import { Select, Option } from 'element-ui'

export default {
  name: 'Badge',
  components: {
    BadgeColor,
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    value: {
      type: String,
      default: 'default'
    },
    tag: {
      type: String,
      default: 'span',
      description: 'Badge tag'
    }
  },
  data() {
    return {
      colorValue: 'default',
      acceptedValues: [
        'primary',
        'success',
        'danger',
        'warning',
        'info',
        'light',
        'dark',
        'red',
        'indigo',
        'purple',
        'pink',
        'yellow',
        'teal',
        'cyan',
        'gray',
        'green',
        'blue',
        'default'
      ]
    }
  },
  watch: {
    value(val) {
      this.colorValue = val
    }
  },
  methods: {
    elementClicked() {
      this.$emit('input', this.colorValue)
    }
  }
}
</script>
<style></style>
